'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HightlightLabel = exports.Heading = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n  font-family: ', ';\n  font-size: ', 'px;\n  font-weight: normal;\n  margin-bottom: 24px;\n  margin-bottom: ', 'px;\n  margin-top: 0;\n  opacity: ', ';\n  position: relative;\n  text-align: ', ';\n  ', '\n  ', '\n  ', '\n\n  ', ';\n'], ['\n  color: ', ';\n  font-family: ', ';\n  font-size: ', 'px;\n  font-weight: normal;\n  margin-bottom: 24px;\n  margin-bottom: ', 'px;\n  margin-top: 0;\n  opacity: ', ';\n  position: relative;\n  text-align: ', ';\n  ', '\n  ', '\n  ', '\n\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    font-size:  ', 'px;\n  '], ['\n    font-size:  ', 'px;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  color: ', ';\n'], ['\n  color: ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _helpers = require('../../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var fontSize = function fontSize(props) {
  return parseInt(props.size, 10) + 1 < 5 ? props.theme.size[(parseInt(props.size, 10) + 1).toString()] : props.theme.size[props.size];
};

var styles = {
  size: {
    fontSize: {
      1: 18,
      2: 16,
      3: 14,
      4: 12,
      5: 10
    },
    marginBottom: {
      1: 24,
      2: 24,
      3: 18,
      4: 16,
      5: 14
    },
    lineHeight: {
      1: 40,
      2: 32,
      3: 24,
      4: 16,
      5: 12
    }
  },
  align: {
    left: 'left',
    center: 'center',
    right: 'right'
  }
};

var Heading = exports.Heading = _styledComponents2.default.h2(_templateObject, function (props) {
  return props.theme.color[props.variant];
}, function (props) {
  return props.theme.font.bold;
}, function (props) {
  return props.theme.size[props.size];
}, (0, _helpers.getStyle)(styles.size.marginBottom, 'size'), function (props) {
  return props.opacity;
}, (0, _helpers.getStyle)(styles.align, 'align'), (0, _helpers.boolStyle)('inline', 'display: inline-block;vertical-align: sub;'), (0, _helpers.boolStyle)('noMargin', 'margin-bottom: 0;'), (0, _helpers.boolStyle)('header', 'line-height: 40px;'), _helpers.media.extraSmallMobile(_templateObject2, function (props) {
  return fontSize(props);
}));

Heading.displayName = 'Heading';
var HightlightLabel = exports.HightlightLabel = _styledComponents2.default.span(_templateObject3, function (props) {
  return props.theme.primary;
});
HightlightLabel.displayName = 'HightlightLabel';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-heading/styles.js
// module id = 2912
// module chunks = 4